import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [testsDropdownOpen, setTestsDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setTestsDropdownOpen(false);
  };

  const toggleTestsDropdown = () => {
    setTestsDropdownOpen(!testsDropdownOpen);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="logo">
          <img src="/logo.ico" alt="مركز آفاق" className="logo-image" />
        </Link>
        <button className={`menu-toggle ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={closeMenu}>الرئيسية</Link>
          <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} onClick={closeMenu}>من نحن</Link>
          <Link to="/trainers" className={`nav-link ${location.pathname === '/trainers' ? 'active' : ''}`} onClick={closeMenu}>المدربين</Link>
          <div className="nav-dropdown">
            <button 
              className={`nav-link dropdown-toggle ${location.pathname.startsWith('/tests') ? 'active' : ''}`} 
              onClick={toggleTestsDropdown}
            >
              الاختبارات
              <span className={`dropdown-arrow ${testsDropdownOpen ? 'open' : ''}`}>▼</span>
            </button>
            <div className={`dropdown-menu ${testsDropdownOpen ? 'show' : ''}`}>
              <Link to="/tests/icdl" className="dropdown-item" onClick={closeMenu}>شهادة ICDL</Link>
              <Link to="/tests/ielts" className="dropdown-item" onClick={closeMenu}>شهادة IELTS</Link>
              <Link to="/tests/toefl" className="dropdown-item" onClick={closeMenu}>شهادة TOEFL</Link>
            </div>
          </div>
          <Link to="/courses" className={`nav-link ${location.pathname === '/courses' ? 'active' : ''}`} onClick={closeMenu}>الدورات</Link>
          <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} onClick={closeMenu}>تواصل معنا</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;

